export default "__VITE_ASSET__CMUAm1dw__"